import React, { useContext } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
} from 'react-admin';
import { useActiveStatus } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminEmployeeCreate = () => {
    const statuses = useActiveStatus();

    return (
        <Create >
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <SelectInput
                    source="status"
                    choices={ statuses }
                />
                <TextInput name="position" source="position" fullWidth />
                <ReferenceInput
                    label="company"
                    source="company"
                    reference="companies"
                >
                    <SelectInput optionText="name"/>
                </ReferenceInput>
                <ReferenceInput
                    label="contact"
                    source="contact"
                    reference="people"
                >
                    <SelectInput optionText="name"/>
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}